// Tab labels/widths/order as given by the design
export const TABS = [
    { label: "BASIC DETAILS", width: 193 },
    { label: "Courses & Batches (4)", width: 265 },
    { label: "Fees", width: 117 },
    { label: "Attendance", width: 182 },
    { label: "DOCUMENTS", width: 177 },
    { label: "Activity", width: 151 },
    { label: "Leaves", width: 130 },
    { label: "Geofence & Holidays", width: 280 },
];

export const TAB_DISPLAY_ORDER = [
    "BASIC DETAILS",
    "Courses & Batches (4)",
    "Fees",
    "Attendance",
    "Leaves",
    "Geofence & Holidays",
    "DOCUMENTS",
    "Activity",
];

export const mobileRegex = /^[6-9]\d{9}$/;
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const BATCH_COLORS = ["#19AAC4", "#C42D19", "#594099", "#0A9396", "#D97706", "#2563EB"];

export const COURSE_BADGE_TOKENS = {
    live: { bg: "#F0F9FF", border: "#7DCDFF", color: "#008BE3", fontFamily: "Roboto, sans-serif", fontWeight: 600 },
    testSeries: { bg: "#FFFBEB", border: "#FBBF24", color: "#D97706", fontFamily: "Roboto, sans-serif", fontWeight: 500 },
    studyMaterials: { bg: "#FEF2F2", border: "#F87171", color: "#DC2626", fontFamily: "Figtree, sans-serif", fontWeight: 500 },
    videoCourse: { bg: "#F2FFDC", border: "#9BD43A", color: "#609900", fontFamily: "Roboto, sans-serif", fontWeight: 500 },
};

export const QUICK_STATS = [
    { label: "Active courses", value: "3" },
    { label: "Attendance", value: "90%" },
    { label: "Total paid", value: "₹1.2L" },
    { label: "Tests taken", value: "82" },
];

export const CALENDAR_COLORS = {
    present: "#C3F3D2",
    absent: "#FFD7D8",
    partial: "#FEE7A8",
    cancelled: "#F2F2F2",
    offday: "#F2F2F2",
};

export const ATTENDANCE_SUBJECT_COLORS = ["#1982C4", "#8AC926", "#FFCA3A", "#FF595E", "#26BBC9", "#D864E3", "#6A4C93", "#F72585"];

export const JUNE_2026_DAYS = [
    { empty: true }, { empty: true }, { empty: true },
    { day: 1, status: 'present' },
    { day: 2, status: 'present' },
    { day: 3, status: 'present' },
    { day: 4, status: 'absent' },
    { day: 5, status: 'cancelled' },
    { day: 6, status: 'partial' },
    { day: 7, status: 'present' },
    { day: 8, status: 'present' },
    { day: 9, status: 'absent' },
    { day: 10, status: 'present' },
    { day: 11, status: 'cancelled' },
    { day: 12, status: 'cancelled' },
    { day: 13, status: 'present' },
    { day: 14, status: 'cancelled' },
    { day: 15, status: 'present', selected: true },
    { day: 16, status: 'present' },
    { day: 17, status: 'present' },
    { day: 18, status: 'cancelled' },
    { day: 19, status: 'cancelled' },
    { day: 20, status: 'present' },
    { day: 21, status: 'present' },
    { day: 22, status: 'present' },
    { day: 23, status: 'present' },
    { day: 24, status: 'present' },
    { day: 25, status: 'cancelled' },
    { day: 26, status: 'cancelled' },
    { day: 27, status: 'partial' },
    { day: 28, status: 'present' },
    { day: 29, status: 'present' },
    { day: 30, status: 'present' },
];

export const JULY_2026_DAYS = [
    { empty: true }, { empty: true }, { empty: true },
    { day: 1, status: 'present' },
    { day: 2, status: 'present' },
    { day: 3, status: 'present' },
    { day: 4, status: 'absent' },
    { day: 5, status: 'cancelled' },
    { day: 6, status: 'present' },
    { day: 7, status: 'cancelled' },
    { day: 8, status: 'present' },
    { day: 9, status: 'absent' },
    { day: 10, status: 'present' },
    { day: 11, status: 'partial' },
    { day: 12, status: 'cancelled' },
    { day: 13, status: 'present' },
    { day: 14, status: 'cancelled' },
    { day: 15, status: 'present' },
    { day: 16, status: 'present' },
    { day: 17, status: 'present' },
    { day: 18, status: 'cancelled' },
    { day: 19, status: 'cancelled' },
    { day: 20, status: 'present' },
    { day: 21, status: 'cancelled' },
    { day: 22, status: 'present' },
    { day: 23, status: 'present' },
    { day: 24, status: 'present' },
    { day: 25, status: 'cancelled' },
    { day: 26, status: 'cancelled' },
    { day: 27, status: 'present' },
    { day: 28, status: 'cancelled' },
    { day: 29, status: 'present' },
    { day: 30, status: 'partial' },
    { day: 31, status: 'present' },
];

export const AUGUST_2026_DAYS = [
    { empty: true }, { empty: true }, { empty: true },
    { day: 1, status: 'present' },
    { day: 2, status: 'present' },
    { day: 3, status: 'present' },
    { day: 4, status: 'absent' },
    { day: 5, status: 'cancelled' },
    { day: 6, status: 'absent' },
    { day: 7, status: 'cancelled' },
    { day: 8, status: 'present' },
    { day: 9, status: 'present' },
    { day: 10, status: 'present' },
    { day: 11, status: 'present' },
    { day: 12, status: 'cancelled' },
    { day: 13, status: 'present' },
    { day: 14, status: 'present' },
    { day: 15, status: 'partial' },
    { day: 16, status: 'present' },
    { day: 17, status: 'cancelled' },
    { day: 18, status: 'present' },
    { day: 19, status: 'cancelled' },
    { day: 20, status: 'present' },
    { day: 21, status: 'partial' },
    { day: 22, status: 'present' },
    { day: 23, status: 'present' },
    { day: 24, status: 'present' },
    { day: 25, status: 'absent' },
    { day: 26, status: 'cancelled' },
    { day: 27, status: 'present' },
    { day: 28, status: 'cancelled' },
    { day: 29, status: 'present' },
    { day: 30, status: 'present' },
    { day: 31, status: 'present' },
];

export const MONTH_NAMES_2026 = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
